import { useQuery } from "@tanstack/react-query";

import { SATOSPortal } from "@/DataAdapter/SATOSPortal";

import { useFetchActiveUser } from "@/service/ApplicationQueries";

export const useFetchOrganizationModules = () => {
	const { data: user } = useFetchActiveUser(true);

	const companyId = user?.CompanyId;

	if (!companyId) {
		throw new Error("No organization Id");
	}

	return useQuery({
		queryKey: [ModulesQueryKeys.organizationModules, companyId],
		queryFn: () => SATOSPortal.OrganizationModules(companyId),
	});
};

export class ModulesQueryKeys {
	static readonly organizationModules = "Organization Modules";
}
